module.exports = __webpack_public_path__ + "img/about-variasi.a0900e64.png";